/**
 * Prism brand lockup — "PRISM · BY AUROUS LABS".
 * Mirrors the prism-landing wordmark (flavienhello/prism-landing): a prism
 * glyph splitting one beam into the four modality hues, gold "by Aurous Labs"
 * tag. Inline SVG so it inherits crisp rendering at any size, no asset fetch.
 */
export function PrismWordmark({ className }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="Prism by Aurous Labs"
      className={`inline-flex items-center gap-2.5 ${className ?? ''}`}
    >
      <svg width="22" height="20" viewBox="0 0 20 18" fill="none" aria-hidden>
        <path d="M10 1 L19 17 H1 Z" stroke="currentColor" strokeWidth="1.6" fill="none" />
        <path d="M10 6 L14.5 15" stroke="#FF5CA8" strokeWidth="1.4" />
        <path d="M10 6 L11.8 15.4" stroke="#C46BFF" strokeWidth="1.4" />
        <path d="M10 6 L8.2 15.4" stroke="#8B7CFF" strokeWidth="1.4" />
        <path d="M10 6 L5.5 15" stroke="#2ED9FF" strokeWidth="1.4" />
      </svg>
      <span className="font-display text-lg font-bold tracking-[0.14em] text-foreground">
        PRISM
      </span>
      <span className="border-l border-border pl-2.5 font-mono text-[9px] font-normal uppercase tracking-[0.24em] text-primary">
        by Aurous Labs
      </span>
    </span>
  );
}
